class CollectionToggleVariant extends HTMLElement {
  async connectedCallback() {
    this.selectors = {
      loadMore: 'load-more',
      link: 'a',
    };

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', evt => {
      if (!evt.target.closest(this.selectors.link)) return;

      evt.preventDefault();

      const href = evt.target.closest(this.selectors.link).href;

      fetch(`${href}${href.includes('?') ? '&' : '?'}sections=main-collection-product-grid`)
        .then(response => response.json())
        .then(data => {
          if (!data['main-collection-product-grid']) return;

          const parser = new DOMParser();
          const doc = parser.parseFromString(data['main-collection-product-grid'], 'text/html');

          const loadMore = document.querySelector(this.selectors.loadMore);
          const newLoadMore = doc.querySelector(this.selectors.loadMore);

          if (!loadMore || !newLoadMore) return;

          loadMore.replaceWith(newLoadMore);

          if (href.includes('view=variant')) {
            document.body.classList.add('suffix-variant');
            Shopify.template = 'collection.variant';
            showProductsByVoltage();
          } else {
            document.body.classList.remove('suffix-variant');
            Shopify.template = 'collection';
          }

          if (window.Yotpo) {
            const api = new Yotpo.API(yotpo);
            api.refreshWidgets();
          }
        });
    });
  }
}

customElements.define('collection-toggle-variant', CollectionToggleVariant);
